import * as yup from 'yup';

export const pepEntrySchema = yup.object({
  full_name: yup.string().required('Full name of PEP is required'),
  position: yup.string().required('Position of PEP is required'),
  relationship: yup.string().required('Relationship to government official is required'),
  specify_relationship: yup.string().when('relationship', {
    is: 'others',
    then: (schema) => schema.required('Please specify the relationship'),
    otherwise: (schema) => schema.optional()
  }),
  position_held: yup.string().required('Position/Office held is required'),
  position_status: yup.string().required('Position status is required'),
  country: yup.string().nullable().required('Country is required'),
  source_of_funds: yup.string().required('Source of funds is required')
});

export const PEP_FORM_FIELDS = [
  'full_name',
  'position',
  'relationship',
  'specify_relationship',
  'position_held',
  'position_status',
  'country',
  'source_of_funds'
];
